// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2WIuh","title":"Images45_title__O3Odp","images":"Images45_images__1s5u4"};